import { api } from '@creditsights/api-ui-web';

export interface SubmitResponse {
  id: string;
}

export const submit = async (payload: FormData): Promise<SubmitResponse> => {
  const { data } = await api.post('document-upload/v1/cr-research', payload);
  return data;
};
